/** 목록·테이블: 항목이 적을 땐 높이 자동, 많아지면 이 값까지 늘었다가 내부 스크롤 */
export const EVENT_LOG_LIST_MAX_HEIGHT = 'min(520px, 55vh)';
export const DISPATCH_HISTORY_TABLE_MAX_HEIGHT = 'min(480px, 50vh)';
